import * as appActions from './app';
import { dialogsReducerActions } from './dialogsSlice';

import type { RootState, Thunk } from '~/store';
import type { IBooster } from '~/types';

import { ACTION_IDS, DWH_EXPORT_EVENTS } from '~/constants';
import dwhExport from '~/dwhExport';
import animationIterator from '~/utils/animationIterator';


// Reducer actions
export const {
    closeBuyGoldDialog,
    openWalletPortal,
    closeWalletPortal,
    openProgressBarPortal,
    closeProgressBarPortal,
    showOverlay,
    hideOverlay,
    closeBoosterDialog,
    openFinalDialog,
    openBuyoutDialog,
    closeBuyoutDialog,
    openErrorDialog,
    closeErrorDialog,
    openWelcomeDialog,
    closeWelcomeDialog,
    closeRulesDialog,
    openMultipleBuyDialog,
    closeMultipleBuyDialog,
    openStartBuyDialog,
    closeStartBuyDialog,
    showLoadError,
    hideLoadError,
    showBlueprintsViewer,
    hideBlueprintsViewer,
    showDownloadGamePopup,
    hideDownloadGamePopup,
    openBundleBuyDialog,
    closeBundleBuyDialog,
    openShipFeaturesDialog,
    closeShipFeaturesDialog,
} = dialogsReducerActions;


// Thunk actions
export const closeFinalDialog = (): Thunk => (dispatch) => {
    animationIterator.actionFinished();

    dispatch(appActions.completeAction(ACTION_IDS.GOLD_REWARD_POPUP));
    dispatch(appActions.updateAvailableRewards(true));
    dispatch(dialogsReducerActions.closeFinalDialog());
};


export const openBoosterDialog = (booster: IBooster): Thunk => (dispatch) => {
    dispatch(appActions.setSelectedBooster(booster));
    dispatch(dialogsReducerActions.openBoosterDialog());
};


export const openRulesDialog = (): Thunk => (dispatch) => {
    dispatch(dialogsReducerActions.openRulesDialog());

    dwhExport.send(DWH_EXPORT_EVENTS.SHOW_RULES);
};


export const openBuyGoldDialog = (): Thunk => (dispatch) => {
    dispatch(dialogsReducerActions.openBuyGoldDialog());

    dwhExport.send(DWH_EXPORT_EVENTS.BUY_GOLD);
};


export const showVideoPlayer = (): Thunk => (dispatch) => {
    dispatch(appActions.switchSync(false));
    dispatch(dialogsReducerActions.showVideoPlayer());
};

export const hideVideoPlayer = (videoType: VideoType): Thunk => (dispatch) => {
    dispatch(appActions.switchSync(true));
    dispatch(dialogsReducerActions.hideVideoPlayer());

    dispatch(appActions.afterSkipVideo(videoType));
};


export const showIntroVideo = (): Thunk => (dispatch) => {
    dispatch(appActions.showIntroVideo());
    dispatch(showVideoPlayer());
};

export const showLaunchVideo = (): Thunk => (dispatch) => {
    dispatch(appActions.showLaunchVideo());
    dispatch(showVideoPlayer());
};

export const showCompleteBlueprintsVideo = (): Thunk => (dispatch) => {
    dispatch(appActions.showCompleteBlueprintsVideo());
    dispatch(showVideoPlayer());
};

export const showFinalVideo = (): Thunk => (dispatch) => {
    dispatch(appActions.showFinalVideo());
    dispatch(showVideoPlayer());
};


export const showLastChanceScreen = (): Thunk => (dispatch, getState: () => RootState) => {
    const state = getState();
    if (state.app.shipLevel === 1) {
        dispatch(dialogsReducerActions.showLastChanceScreen());
    }
};
